import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_ActiveTable = _resolveComponent("ActiveTable")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.page)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['header-row'])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.title)
      }, _toDisplayString(_ctx.t('listTitle')), 3),
      _createVNode(_component_SelectInput, {
        modelValue: _ctx.filterModel.filter,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterModel.filter) = $event)),
        class: _normalizeClass(["action-select-input", _ctx.$style['filter-input']]),
        placeholder: _ctx.rootT('panel.constructor.filters.filter.placeholder'),
        options: _ctx.filterOptions,
        "allow-empty": false,
        state: ['primary', 'tertiary']
      }, null, 8, ["modelValue", "class", "placeholder", "options"])
    ], 2),
    _createVNode(_component_ActiveTable, {
      sort: _ctx.sort,
      "onUpdate:sort": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sort) = $event)),
      "table-key": "templates",
      "key-field": "id",
      columns: _ctx.columns,
      records: _ctx.records,
      actions: _ctx.actions,
      class: _normalizeClass(_ctx.$style.table),
      state: "secondary"
    }, {
      "cell(production_type)": _withCtx(({record}) => [
        _createTextVNode(_toDisplayString(_ctx.rootT(`productionType.${record.production_type}`)), 1)
      ]),
      _: 1
    }, 8, ["sort", "columns", "records", "actions", "class"])
  ], 2))
}